export type DevicePlatform = 'android' | 'ios';
export type WalletProvider = 'apple' | 'google';

export function getDevicePlatform(userAgent: string): DevicePlatform | undefined {
    if (/android/i.test(userAgent)) {
        return 'android';
    }

    if (/iPad|iPhone|iPod/i.test(userAgent) || (/Macintosh/i.test(userAgent) && /Mobile/i.test(userAgent))) {
        return 'ios';
    }

    return undefined;
}

export function getWalletProviderForUserAgent(userAgent: string): WalletProvider | undefined {
    const platform = getDevicePlatform(userAgent);

    if (platform === 'android') {
        return 'google';
    }

    if (platform === 'ios') {
        return 'apple';
    }

    return undefined;
}
